module.exports = __webpack_public_path__ + "img/sit_reach_card.cb00c5f0.svg";